module.exports = __webpack_public_path__ + "static/img/logo.b8af83e.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/logo.png
// module id = VHuu
// module chunks = 1